import { render, staticRenderFns } from "./carouselProductContent.vue?vue&type=template&id=5abc207e&scoped=true"
import script from "./carouselProductContent.vue?vue&type=script&lang=js"
export * from "./carouselProductContent.vue?vue&type=script&lang=js"
import style0 from "./carouselProductContent.vue?vue&type=style&index=0&id=5abc207e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abc207e",
  null
  
)

export default component.exports